export default __webpack_public_path__ + "static/gs-2-target-6ab537d849ace93300253b59e0e2fd2d.webp";